import { render, staticRenderFns } from "./__MenuSection.vue?vue&type=template&id=c20c590a&scoped=true&"
var script = {}
import style0 from "./__MenuSection.vue?vue&type=style&index=0&id=c20c590a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c590a",
  null
  
)

export default component.exports